import React, { Component } from 'react';
import { observer , inject } from 'mobx-react';



class Under18Modal extends Component {

    parentPressed = (e) => {
        this.props.DGRModalStore.closeModal()
        this.props.history.push('guardian');
    }
    alonePressed = (e) => {
        //TODO see front desk 
        //change modal and send to front desk 
        this.props.history.push('');

    }

    render() {
        return(
            <div> 
                Guardian Required. 
                <button onClick={this.alonePressed}>
                   I am alone. 
                </button>
                <button onClick={this.parentPressed}>
                   I have my Parent or Guardian Here 
                </button>
                <br/>
            </div>
        );
    }
}

Under18Modal = inject('DGRStore','DGRModalStore')(observer(Under18Modal))     
export default Under18Modal;



// WEBPACK FOOTER //
// ./src/components/DGR/Modal/Under18Modal.js